import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const LocalizationSection = () => {
    return (
        <div id="localization">
            <h1>Language Support & Localized Content</h1>
            <section className="narrow">
                <p>We support the following languages and have locale specific
                content for many regions where these languages are spoken: </p>
                <div className="language-list">
                    <ul className="bullet-list left-align">
                        <li>Portuguese</li>
                        <li>English</li>
                        <li>Spanish</li>
                        <li>Italian</li>
                        <li>German</li>
                        <li>Arabic</li>
                        <li>Russian</li>
                        <li>French</li>
                        <li>Albanian</li>
                        <li>Slovak</li>
                        <li>Indonesian</li>
                        <li>Simplified Chinese</li>
                        <li>Traditional Chinese</li>
                        <li>Japanese</li>
                        <li>Korean</li>
                        <li>Hindi </li>
                        <li>Turkish</li>
                        <li>Dutch</li>
                        <li>Bengali</li>
                        <li>Tagalog</li>
                    </ul>
                    <ul className="bullet-list left-align">

                        <li>Hebrew</li>
                        <li>Finnish</li>
                        <li>Swedish</li>
                        <li>Danish</li>
                        <li>Czech</li>
                        <li>Polish</li>
                        <li>Romanian</li>
                        <li>Malay</li>
                        <li>Cantonese</li>
                        <li>Urdu</li>
                        <li>Norwegian (Bokmal)</li>
                        <li>Norwegian (Nynorsk)</li>
                        <li>Catalan</li>
                        <li>Greek</li>
                        <li>Hungarian</li>
                        <li>Thai</li>
                        <li>Farsi</li>
                        <li>Ukrainian</li>
                        <li>Croatian</li>
                        <li>Vietnamese</li>
                    </ul>
                </div>
            </section>
        </div>
    );
};
